module.exports = __webpack_public_path__ + "img/04_green_dance.575c67a5.gif";